import { showConfirmationPrompt } from '@bpinternal/ui-kit-next'
import { showAddonAutoRechargeDialog } from '../components/AddonAutoRechargeDialog'
import { useActiveSubscription } from './useActiveSubscription'
import { useCreateSubscription } from './useCreateSubscription'

export const useAutoRechargeDialog = (addonProductId: string, workspaceId: string) => {
  const { monthly: monthlyActiveSubscription } = useActiveSubscription(workspaceId)
  const { mutate: createSubscription } = useCreateSubscription(workspaceId)

  return async () => {
    if (monthlyActiveSubscription) {
      showAddonAutoRechargeDialog(addonProductId, workspaceId)
    } else {
      const confirm = await showConfirmationPrompt(<p>Add a payment method to enable Auto Recharge</p>, {
        title: 'Payment Method Required',
        confirmLabel: 'Add Payment Method',
      })
      if (confirm) createSubscription()
    }
  }
}
